// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__35xfG","calendarButtons":"ClockData_calendarButtons__2tVuq"};